import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { adminGetDashboardUsersDataApi } from '../../../api/dashboard/adminGetDashboardUsersDataApi';
import { AdminDashboardUsersStaticsResponse } from '../../../graphql/API';

export const useAdminGetDashboardUsersDataQuery = (): UseQueryResult<
  AdminDashboardUsersStaticsResponse,
  Error
> => {
  const adminGetDashboardQuery = useQuery({
    queryKey: ['admin-get-dashboard-users-data'],
    queryFn: () => adminGetDashboardUsersDataApi(),
  });
  return { ...adminGetDashboardQuery };
};
